import { SVGAttributes } from 'react';

export default function ApplicationLogo(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140.82 91.78"
      {...props}
    >
      <defs>
        <style>
          {'.cls-1{fill:#231f20;}.cls-2{fill:#e6e7e8;}.cls-3{fill:#db6015;}'}
        </style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M3.13,83.76H.06v-1.1h7.4v1.1H4.39v7.86H3.13Z"
          />
          <path
            className="cls-1"
            d="M13.24,82.51a4.51,4.51,0,0,1,4.59,4.57,4.6,4.6,0,1,1-9.2,0A4.53,4.53,0,0,1,13.24,82.51Zm0,8.11a3.39,3.39,0,0,0,3.3-3.54,3.31,3.31,0,1,0-6.61,0A3.39,3.39,0,0,0,13.24,90.62Z"
          />
          <path className="cls-1" d="M20.29,82.66h1.25v7.87h4v1.09H20.29Z" />
          <path
            className="cls-1"
            d="M28.07,82.66h1.32l2.06,4.85c.2.5.44,1.21.44,1.21h0s.24-.71.44-1.21l2.06-4.85h1.32l.72,9H35.22L34.77,86c0-.55,0-1.32,0-1.32h0s-.27.82-.49,1.32l-1.79,4H31.35l-1.78-4c-.2-.49-.48-1.35-.48-1.35h0s0,.8,0,1.35l-.43,5.64H27.35Z"
          />
          <path
            className="cls-1"
            d="M43.69,89.05H40.31l-.89,2.57H38.13l3.22-9h1.32l3.23,9H44.59ZM42,83.9s-.2.81-.35,1.26l-1,2.85h2.72l-1-2.85c-.15-.45-.34-1.26-.34-1.26Zm.38-3.47H43.7L42.48,82h-1Z"
          />
          <path
            className="cls-1"
            d="M51.74,82.51A4.6,4.6,0,0,1,55,83.69l-.62.94a4.08,4.08,0,0,0-2.59-1,3.26,3.26,0,0,0-3.31,3.43,3.36,3.36,0,0,0,3.33,3.54,4,4,0,0,0,2.76-1.17l.67.9a4.78,4.78,0,0,1-3.47,1.43,4.51,4.51,0,0,1-4.58-4.69A4.47,4.47,0,0,1,51.74,82.51Z"
          />
          <path
            className="cls-1"
            d="M57.61,89.64a3.53,3.53,0,0,0,2.29,1,1.38,1.38,0,0,0,1.54-1.32c0-1.94-4.34-1.52-4.34-4.28a2.66,2.66,0,0,1,2.9-2.5,3.65,3.65,0,0,1,2.53.9l-.57,1a3.14,3.14,0,0,0-2-.77A1.47,1.47,0,0,0,58.37,85c0,1.85,4.34,1.36,4.34,4.26a2.58,2.58,0,0,1-2.84,2.53,4.2,4.2,0,0,1-3-1.18Z"
          />
          <path
            className="cls-1"
            d="M65.17,89.64a3.52,3.52,0,0,0,2.28,1A1.38,1.38,0,0,0,69,89.29c0-1.94-4.34-1.52-4.34-4.28a2.66,2.66,0,0,1,2.9-2.5,3.65,3.65,0,0,1,2.53.9l-.57,1a3.14,3.14,0,0,0-2-.77A1.47,1.47,0,0,0,65.93,85c0,1.85,4.34,1.36,4.34,4.26a2.58,2.58,0,0,1-2.84,2.53,4.2,4.2,0,0,1-3-1.18Z"
          />
          <path
            className="cls-1"
            d="M72,90.79l4.31-6.22a6.44,6.44,0,0,1,.65-.83v0a4.59,4.59,0,0,1-.68,0H72.23v-1.1h6.3v.83l-4.32,6.23a7.81,7.81,0,0,1-.64.81v0a6,6,0,0,1,.67,0h4.34v1.09H72Z"
          />
          <path
            className="cls-1"
            d="M84.91,82.51a4.51,4.51,0,0,1,4.59,4.57,4.6,4.6,0,1,1-9.2,0A4.53,4.53,0,0,1,84.91,82.51Zm0,8.11a3.39,3.39,0,0,0,3.3-3.54,3.31,3.31,0,1,0-6.62,0A3.4,3.4,0,0,0,84.91,90.62Z"
          />
          <path className="cls-1" d="M92,82.66h1.25v7.87h4v1.09H92Z" />
          <path
            className="cls-1"
            d="M103,82.51a4.85,4.85,0,0,1,3.26,1.08l-.63.94a4.11,4.11,0,0,0-2.53-.88,3.49,3.49,0,0,0-.07,7,3.66,3.66,0,0,0,2.54-1.12V88.21h-1.46V87.12h2.6v4.5h-1.11v-.55c0-.2,0-.39,0-.39h0a3.85,3.85,0,0,1-2.75,1.1,4.44,4.44,0,0,1-4.41-4.65A4.52,4.52,0,0,1,103,82.51Z"
          />
          <path
            className="cls-1"
            d="M113.79,89.05h-3.38l-.89,2.57h-1.29l3.22-9h1.32l3.22,9h-1.3ZM112.1,83.9s-.21.81-.36,1.26l-1,2.85h2.72l-1-2.85c-.16-.45-.35-1.26-.35-1.26Zm.38-3.47h1.32L112.58,82h-1Z"
          />
          <path className="cls-1" d="M117.94,82.66h1.26v7.87h4v1.09h-5.27Z" />
          <path
            className="cls-1"
            d="M129.85,89.05h-3.37l-.89,2.57H124.3l3.22-9h1.32l3.22,9h-1.31Zm-1.69-5.15s-.2.81-.35,1.26l-1,2.85h2.71l-1-2.85c-.15-.45-.34-1.26-.34-1.26Z"
          />
          <path
            className="cls-1"
            d="M135.38,83.76h-3.07v-1.1h7.4v1.1h-3.07v7.86h-1.26Z"
          />
          <path
            className="cls-1"
            d="M13.3,70.34c-.3-1.09-.55-2.08-.79-3-1.23-4.81-2-7.71-5.54-12.71l-.31-.45c-.72-1-1.94-2.77-1.94-3.84,0-3.44,2-6.51,4.14-9.77s4.46-6.81,4.46-10.83a1.83,1.83,0,0,0-1.81-1.93,1.87,1.87,0,0,0-1.93,1.7C9,32.84,7.18,35.85,5.4,38.77c-.52.86-1.05,1.73-1.55,2.61,0-4,0-8,0-11.87a2.16,2.16,0,0,0-1.87-1.88A1.88,1.88,0,0,0,.06,29.51V69.18c0,.22,0,.52,0,.87-.1,2.58-.1,5.18,1,6.29a1.66,1.66,0,0,0,1.23.53,1.81,1.81,0,0,0,1.75-2q0-5.09,0-10.2,0-3.83,0-7.67l.41.73C6.07,60.82,8,64.31,8.68,67c0,.17.09.42.15.72,1.14,5.56,2.21,9,4,9a1.87,1.87,0,0,0,1.88-1.81,14.07,14.07,0,0,0-.83-2.72C13.63,71.36,13.37,70.61,13.3,70.34Z"
          />
          <path
            className="cls-1"
            d="M65.05,28.6a2.16,2.16,0,0,0-1.88-1.87A1.82,1.82,0,0,0,61.3,28.6c0,3.58,0,7.14.09,10.7,0,3.33.08,6.67.09,10-1.19-6.8-2.87-15.11-5.37-20.56-.18-.53-1-1.54-1.84-1.54-1.09,0-1.82.88-1.82,2.18,0,5.55-.3,11.19-.6,16.65s-.61,11.13-.61,16.72c0,.26,0,.66,0,1.17-.16,8.35.2,12.19,1.23,13.24a1.14,1.14,0,0,0,.84.37,1.84,1.84,0,0,0,1.88-1.88c0-10.66.31-21.42,1-32.75A100.08,100.08,0,0,1,59,59c.18,1.93.19,4.11.2,6.42,0,3.68,0,7.5.79,10.54.16.57.85,1.81,1.85,1.81.57,0,1.57-.24,1.87-1.89,1.4-8.67,1.52-17.88,1.52-26.57,0-3.42,0-6.85-.09-10.29S65.05,32.06,65.05,28.6Z"
          />
          <path
            className="cls-1"
            d="M80.68,27.82H70.8a1.88,1.88,0,0,0,0,3.75h3.28c0,7.09.12,14.31.24,21.3.12,7.2.24,14.65.24,21.95a2.16,2.16,0,0,0,1.88,1.87,1.82,1.82,0,0,0,1.87-1.87c0-7.31-.12-14.76-.24-22-.11-7-.23-14.2-.24-21.28h2.85a1.88,1.88,0,0,0,0-3.75Z"
          />
          <path
            className="cls-1"
            d="M104.11,58.64a1.87,1.87,0,0,0-1.87-1.87h-.17c-.22-1.27-.45-2.54-.67-3.81-1.35-7.52-2.74-15.3-2.74-23.09,0-.68-.85-2.12-1.81-2.12A2,2,0,0,0,95,29.28c-2.93,8-4.22,17.23-5.46,26.11l0,.39-.28,0a1.88,1.88,0,0,0-1.82,1.94c0,.73.53,1.31,1.56,1.72-.08.5-.16,1-.25,1.51s-.19,1.14-.27,1.69a52.15,52.15,0,0,1-1.69,6c-.94,3-1.83,5.73-1.83,7.24a2.31,2.31,0,0,0,1.42,2l.17.07.18,0c1.15-.13,2.66-1.64,5.9-17.74,2.17.24,4.6.34,6.42.36A100.33,100.33,0,0,1,100.36,76a2.16,2.16,0,0,0,1.88,1.87A1.82,1.82,0,0,0,104.11,76a102.72,102.72,0,0,0-1.41-15.58A1.68,1.68,0,0,0,104.11,58.64Zm-5.75-2c-1.93-.06-3.5-.18-5-.36.86-4.52,1.63-9,2.2-12.37.1-.58.19-1.14.28-1.66.48,3,1,6.07,1.58,9C97.72,53.11,98.05,54.9,98.36,56.68Z"
          />
          <path
            className="cls-1"
            d="M122.32,70.34c-.29-1.09-.55-2.08-.78-3-1.24-4.81-2-7.71-5.55-12.71l-.31-.45c-.72-1-1.94-2.77-1.94-3.84,0-3.44,2-6.51,4.14-9.77s4.47-6.81,4.47-10.83a1.83,1.83,0,0,0-1.82-1.93,1.87,1.87,0,0,0-1.93,1.7c-.56,3.32-2.4,6.33-4.18,9.25-.52.86-1,1.73-1.55,2.61,0-4,0-8,0-11.87A2.17,2.17,0,0,0,111,27.63a1.88,1.88,0,0,0-1.87,1.88V69.18c0,.22,0,.52,0,.87-.09,2.58-.1,5.18,1,6.29a1.67,1.67,0,0,0,1.23.53,1.82,1.82,0,0,0,1.76-2c0-3.39,0-6.79,0-10.2L113,57l.41.73c1.72,3.08,3.68,6.57,4.33,9.23,0,.17.09.42.15.72,1.15,5.56,2.21,9,4,9a1.87,1.87,0,0,0,1.88-1.81,14.29,14.29,0,0,0-.82-2.72C122.65,71.36,122.4,70.61,122.32,70.34Z"
          />
          <path
            className="cls-1"
            d="M138.94,27.82h-9.87a1.88,1.88,0,1,0,0,3.75h3.27c0,7.09.13,14.31.25,21.3.11,7.2.24,14.65.24,21.95a2.14,2.14,0,0,0,1.87,1.87,1.83,1.83,0,0,0,1.88-1.87c0-7.31-.12-14.76-.24-22-.12-7-.24-14.2-.24-21.28h2.84a1.88,1.88,0,1,0,0-3.75Z"
          />
          <path
            className="cls-2"
            d="M46,52.89c0,3.85-6.64,6.92-14.76,6.85s-14.67-3.26-14.64-7.11,6.65-6.92,14.76-6.85S46,49,46,52.89Z"
          />
          <path
            className="cls-2"
            d="M22.49,9.52c0,1.32-2.07,2.37-4.59,2.35s-4.56-1.11-4.55-2.43,2.07-2.37,4.59-2.34S22.5,8.2,22.49,9.52Z"
          />
          <path
            className="cls-2"
            d="M66.15,20.65c0,2-3.64,3.59-8.09,3.56s-8-1.7-8-3.7,3.63-3.59,8.08-3.56S66.16,18.65,66.15,20.65Z"
          />
          <path
            className="cls-3"
            d="M46.25,38.25a14.7,14.7,0,1,1-15-14.35A14.7,14.7,0,0,1,46.25,38.25Z"
          />
          <path
            className="cls-3"
            d="M21.91,4.46A4.57,4.57,0,1,1,17.23,0,4.58,4.58,0,0,1,21.91,4.46Z"
          />
          <path
            className="cls-3"
            d="M66.34,12.92A8.05,8.05,0,1,1,58.1,5.06,8.06,8.06,0,0,1,66.34,12.92Z"
          />
          <path
            className="cls-3"
            d="M44.52,27.54a36,36,0,0,1,7.07-7.38,31.8,31.8,0,0,1-3.27,3.94A31.89,31.89,0,0,1,44.52,27.54Z"
          />
          <path
            className="cls-3"
            d="M48.72,11.08c-2.14-.23-4.26-.54-6.38-.86S38.12,9.52,36,9.17,31.79,8.39,29.7,8s-4.19-.88-6.28-1.41c2.14.23,4.26.54,6.38.86s4.22.7,6.33,1.05,4.21.78,6.31,1.22S46.63,10.56,48.72,11.08Z"
          />
          <path
            className="cls-3"
            d="M18.7,10.55A56.4,56.4,0,0,1,21.58,17a59,59,0,0,1,2.21,6.66,57.21,57.21,0,0,1-2.88-6.4A61.12,61.12,0,0,1,18.7,10.55Z"
          />
        </g>
      </g>
    </svg>
  );
}
